import { BaseNavigation } from './baseNavigation'
import { TranslationService } from '../Translation'

export class MyTripsNavigation extends BaseNavigation {
	static path: string = 'my-trips'

	static get route(): string {
		const translation = TranslationService.getInstance()
		return `/${translation.getLocale()}/${this.path}/`
	}

	static go(): unknown {
		return this.navigateTo(this.route)
	}
}
